const newToken={
    hCaptchaSiteToken:"07c6c620-7b2b-48df-bad5-46151fef3f29"
}
export default newToken;